import styles from './EditCourse.module.scss';
import {
  faCheck,
  faCheckSquare,
  faCross,
  faEdit,
  faExclamation,
  faEye,
  faEyeSlash,
  faLock,
  faLockOpen,
  faPlus,
  faQuestion,
  faSave,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Alert, Badge, Button, Card, Col, Form, InputGroup, ListGroup, Modal, Pagination, Row } from 'react-bootstrap';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { Copyable } from '../Copyable/Copyable';
import { useDetectChanges } from '../../../hooks/useDetectChanges';
import { set } from 'lodash';
import { detect } from 'csv-string';
import { faSquare } from '@fortawesome/free-regular-svg-icons';

const EditCourseComponent = ({
  course = null,
  loading = false,
  editCourseModal = false,
  setEditCourseModal = (stata: boolean) => {},
  setLoading = (state: boolean) => {},
  fetchContent = () => {},
  setCourseId = (id?: string) => {},
  isCourseReadOnly = false,
}) => {
  const { updateCourse, getCompanies, database, fv } = useFirebase();
  const [editCourse, setEditCourse] = useState<{
    id?: string;
    name: string;
    withCertificate: boolean;
    visibleForAso: boolean;
    companyId?: string;
    companyName?: string;
    description: string[];
    visible: boolean;
    order: number;
    maxErrors: number;
  }>({
    id: null,
    name: '',
    withCertificate: false,
    visibleForAso: false,
    companyId: null,
    companyName: null,
    description: [],
    visible: false,
    order: 0,
    maxErrors: 0,
  });
  const [editCourseCompany, setEditCourseCompany] = useState({ id: '', name: '' });
  const [editCourseCompanyModal, setEditCourseCompanyModal] = useState(false);
  const [newDescription, setNewDescription] = useState('');
  const [companies, setCompanies] = useState([]);
  const detectChanges = useDetectChanges();

  const [newUnit, setNewUnit] = useState({
    name: '',
    guid: '',
    minimumTime: '0',
  });

  const [showTestsModal, setShowTestsModal] = useState(false);
  const [showUnitsModal, setShowUnitsModal] = useState(false);
  const [tests, setTests] = useState([]);
  const [newTestName, setNewTestName] = useState('');
  const [newQuestionModal, setNewQuestionModal] = useState(false);
  const [question, setQuestion] = useState('');
  const [currentTest, setCurrentTest] = useState(null);
  const [newAnswerModal, setNewAnswerModal] = useState(false);
  const [answer, setAnswer] = useState('');
  const [currentQuestion, setCurrentQuestion] = useState(null);

  const [units, setUnits] = useState([]);
  const [chapterId, setChapterId] = useState(null);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    getCompanies().then(setCompanies);
  }, []);

  useEffect(() => {
    if (course) {
      const visibleForAso = course.visibleFor?.some((item) => item.categoriaProfessionale === 'aso');
      const company = course.companies?.length === 1 ? course.companies[0] : null;

      setEditCourse({
        id: course.id,
        name: course.name,
        withCertificate: course.withCertificate,
        visibleForAso: visibleForAso || false,
        companyId: company?.id,
        companyName: company?.name,
        description: course.description || [],
        visible: course.visible,
        order: course.order,
        maxErrors: course.maxErrors,
      });

      setTests(course.tests.sort((a, b) => (a.order || 0) - (b.order || 0)));
      setUnits(course.chapters?.length ? course.chapters[0].units : []);
      setChapterId(course.chapters?.length ? course.chapters[0].id : null);
    } else {
      setEditCourse({
        name: '',
        withCertificate: false,
        visibleForAso: false,
        companyId: null,
        companyName: null,
        description: [],
        visible: false,
        order: 0,
        maxErrors: 0,
      });
    }
  }, [course]);

  const removeDescriptionItem = (index: number) => {
    setEditCourse((prev) => ({ ...prev, description: prev.description.filter((_, i) => i !== index) }));
  };

  const addDescriptionItem = () => {
    setEditCourse((prev) => ({ ...prev, description: [...prev.description, newDescription] }));
    setNewDescription('');
  };

  const updateCurrentCourse = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateCourse(
        editCourse.name,
        editCourse.withCertificate,
        editCourse.visibleForAso,
        editCourse.description,
        editCourse.visible,
        editCourse.order,
        editCourse.maxErrors,
        editCourse.companyId,
        editCourse.id
      );
      // setEditCourse({
      //   id: null,
      //   name: '',
      //   withCertificate: false,
      //   visibleForAso: false,
      //   companyId: null,
      //   companyName: null,
      //   description: [],
      //   visible: false,
      //   order: 0,
      // });
      setEditCourseModal(false);
      setCourseId(null);
      fetchContent();
    } catch (error) {
      console.error(error);
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Modal
        size={'xl'}
        className={'dark-modal'}
        centered
        show={editCourseModal}
        onHide={() => {
          setEditCourseModal(false);
          setCourseId(null);
          fetchContent();
        }}
        backdrop={'static'}
        keyboard={false}
      >
        <Modal.Body className="pb-0">
          <Card bg="dark">
            <Card.Header className="text-white">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0">
                  {course ? 'Modifica il corso' : 'Crea un nuovo corso'} {!!course && <Copyable text={course.id} />}
                </h4>
                {course && (
                  <div className="d-flex align-items-center">
                    <Button
                      as={Badge}
                      onClick={() => {
                        setShowTestsModal(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                      <span className={'ml-1'}>Test</span>
                    </Button>
                    <Button
                      as={Badge}
                      className={'ml-2'}
                      onClick={() => {
                        setShowUnitsModal(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                      <span className={'ml-1'}>Unità</span>
                    </Button>
                  </div>
                )}
              </div>
            </Card.Header>
            <Card.Body>
              {isCourseReadOnly && (
                <Alert variant="warning">
                  <Alert.Heading>Attenzione</Alert.Heading>
                  <div>
                    <strong>Il corso è modificabile solo in alcune parti.</strong>
                  </div>
                  {typeof course?.completions === 'number' && <div><strong>Completato da {course.completions} utenti.</strong></div>}
                  <div>Se non è stato completato da nessun utente, rimuovere lo stato "visibile" per abilitare le modifiche.</div>
                  <div>Se è stato completato da almeno un utente, non è più possibile modificare le parti bloccate.</div>
                </Alert>
              )}
              {!isCourseReadOnly && typeof course?.completions === 'number' && (
                <Alert variant="info">
                  <strong>Completato da {course.completions} utenti.</strong>
                </Alert>
              )}
              {showError && (
                <Alert variant="danger" onClose={() => setShowError(false)} dismissible>
                  <Alert.Heading>Errore</Alert.Heading>
                  <div>Si è verificato un errore durante il salvataggio del corso</div>
                </Alert>
              )}
              <Form>
                <Form.Group controlId="editCourseName">
                  <Form.Label>Nome</Form.Label>
                  <Form.Control
                    required
                    isValid={editCourse.name.length > 0}
                    isInvalid={editCourse.name.length === 0}
                    type="text"
                    placeholder="Inserisci il nome del corso"
                    value={editCourse.name}
                    onChange={(e) => {
                      setEditCourse((prev) => ({ ...prev, name: e.target.value }));
                    }}
                  />
                </Form.Group>
                <Row>
                  <Col>
                    <Form.Check
                      type="checkbox"
                      checked={editCourse.withCertificate}
                      label={'Con certificato'}
                      onChange={(e) => {
                        setEditCourse((prev) => ({ ...prev, withCertificate: e.target.checked }));
                      }}
                    />
                  </Col>
                  <Col>
                    <Form.Check
                      type="checkbox"
                      label={'Visibile'}
                      disabled={!course}
                      checked={editCourse.visible}
                      onChange={(e) => {
                        setEditCourse((prev) => ({ ...prev, visible: e.target.checked }));
                      }}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Check
                      checked={editCourse.visibleForAso}
                      disabled={isCourseReadOnly}
                      type="checkbox"
                      label={'Corso ASO'}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setEditCourse((prev) => ({ ...prev, companyId: null, companyName: null }));
                        }
                        setEditCourse((prev) => ({ ...prev, visibleForAso: e.target.checked }));
                      }}
                    />
                  </Col>
                  <Col>
                    <Row>
                      <Col>
                        <Form.Check
                          checked={!!editCourse.companyId}
                          type="checkbox"
                          disabled={isCourseReadOnly}
                          label={'Corso Azienda'}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setEditCourse((prev) => ({ ...prev, visibleForAso: false }));
                            }
                            e.target.checked ? setEditCourseCompanyModal(true) : setEditCourse((prev) => ({ ...prev, companyId: null, companyName: null }));
                          }}
                        />
                      </Col>
                      {editCourse.companyId && (
                        <Col>
                          <Form.Group>
                            <Form.Label>Id Azienda</Form.Label>
                            <Form.Label>{editCourse.companyId}</Form.Label>
                          </Form.Group>
                        </Col>
                      )}
                      {editCourse.companyName && (
                        <Col>
                          <Form.Group>
                            <Form.Label>Nome Azienda</Form.Label>
                            <Form.Label>{editCourse.companyName}</Form.Label>
                          </Form.Group>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>Ordine</Form.Label>
                      <Form.Control
                         className={styles.smallNumberInput}
                        type={'number'}
                        value={editCourse.order}
                        size={'sm'}
                        onChange={(e) => setEditCourse((prev) => ({ ...prev, order: +e.target.value }))}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>N. massimo errori</Form.Label>
                      <Form.Control
                         className={styles.smallNumberInput}
                        type={'number'}
                        value={editCourse.maxErrors}
                        size={'sm'}
                        onChange={(e) => setEditCourse((prev) => ({ ...prev, maxErrors: +e.target.value }))}
                      />
                    </Form.Group>
                    <Form.Group></Form.Group>
                  </Col>
                </Row>
                <Form.Group>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      value={newDescription}
                      onChange={(e) => setNewDescription(e.target.value)}
                      placeholder="Inserisci una descrizione"
                    />
                    <InputGroup.Append>
                      <Button variant="primary" className="float-right" size="sm" onClick={() => addDescriptionItem()}>
                        <FontAwesomeIcon icon={faPlus} fixedWidth={true} />
                      </Button>
                    </InputGroup.Append>
                  </InputGroup>
                </Form.Group>
                {editCourse.description.length > 0 && editCourse.description.length > 0 && (
                  <>
                    <Form.Label>Elenco descrizioni</Form.Label>

                    {editCourse.description.map((item, index) => (
                      <InputGroup key={index.toString()}>
                        <Form.Control type="text" value={item} readOnly />
                        <InputGroup.Append>
                          <Button variant="danger" className="float-right" size="sm" onClick={() => removeDescriptionItem(index)}>
                            <FontAwesomeIcon icon={faTrash} fixedWidth={true} />
                          </Button>
                        </InputGroup.Append>
                      </InputGroup>
                    ))}
                  </>
                )}
              </Form>
            </Card.Body>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant={'secondary'}
            onClick={() => {
              setEditCourseModal(false);
              setCourseId(null);
              fetchContent();
            }}
          >
            Annulla
          </Button>
          <Button variant={'primary'} disabled={editCourse.name.length === 0 || loading} onClick={updateCurrentCourse}>
            {course ? 'Aggiorna' : 'Crea'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size={'xl'}
        className={'dark-modal'}
        centered
        show={editCourseCompanyModal}
        onHide={() => setEditCourseCompanyModal(false)}
        backdrop={'static'}
        keyboard={false}
      >
        <Modal.Body className="pb-0">
          <Card bg="dark">
            <Card.Header>
              <h4 className="mb-0">Seleziona azienda</h4>
            </Card.Header>
            <Card.Body>
              <Form>
                <Form.Group>
                  <Form.Label>Nome</Form.Label>
                  <Form.Control
                    as="select"
                    value={editCourseCompany.id}
                    onChange={(e: any) => {
                      const id = e.target.value;
                      const name = e.target.options[e.target.selectedIndex].text;
                      setEditCourseCompany({ id, name });
                    }}
                  >
                    <option value="">Seleziona un'azienda</option>
                    {companies.map((company) => (
                      <option value={company.id} key={company.id}>
                        {company.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Form>
            </Card.Body>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <Button variant={'secondary'} onClick={() => setEditCourseCompanyModal(false)}>
            Annulla
          </Button>
          <Button
            disabled={!editCourseCompany.id}
            variant={'primary'}
            onClick={() => {
              setEditCourse((prev) => ({ ...prev, companyId: editCourseCompany.id, companyName: editCourseCompany.name }));
              setEditCourseCompanyModal(false);
            }}
          >
            Seleziona
          </Button>
        </Modal.Footer>
      </Modal>

      {!!course && !!tests && (
        <Modal
          size={'xl'}
          className={'light-modal'}
          centered
          show={showTestsModal}
          onHide={() => setShowTestsModal(false)}
          backdrop={'static'}
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Test del corso</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!isCourseReadOnly && (
              <Card>
                <Card.Header>
                  <Card.Title className={'mb-0'}>Aggiungi nuovo test</Card.Title>
                </Card.Header>
                <Card.Body>
                  <InputGroup className="mb-1">
                    <InputGroup.Prepend>
                      <InputGroup.Text>Nome:</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control type="text" placeholder="Inserisci il nome del test" value={newTestName} onChange={(e) => setNewTestName(e.target.value)} />
                  </InputGroup>
                </Card.Body>
                <Card.Footer>
                  <Button
                    variant={'primary'}
                    disabled={!newTestName}
                    onClick={async () => {
                      const maxOrder = tests.length ? Math.max(...tests.map((t) => t.order)) : 0;
                      const newTest = { name: newTestName, order: maxOrder + 10 };

                      const testRef = await database.collection(`courses/${course.id}/tests`).add(newTest);
                      tests.push({ ...newTest, id: testRef.id });
                      setNewTestName('');
                    }}
                  >
                    Aggiungi
                  </Button>
                </Card.Footer>
              </Card>
            )}
            {tests && !!tests.length && (
              <>
                {tests.map((test, index) => (
                  <Card key={test.id} className={'mt-2'} bg={(test.questions?.length ?? 0) >= 1 ? 'light' : 'warning'}>
                    <Card.Header>
                      <Card.Title className={'mb-0'}>
                        <div className={'d-flex justify-content-between align-items-center'}>
                          <div className={'d-flex align-items-center flex-grow-1'}>
                            <InputGroup>
                              <InputGroup.Prepend>
                                <InputGroup.Text>Test {index + 1}</InputGroup.Text>
                              </InputGroup.Prepend>
                              <Form.Control
                                required
                                placeholder={'Inserisci il titolo del test'}
                                value={test.name}
                                onChange={(e) => {
                                  test.name = e.target.value;
                                  detectChanges();
                                }}
                              />
                              <InputGroup.Append>
                                <InputGroup.Text>
                                  <Copyable text={test.id} />
                                </InputGroup.Text>
                              </InputGroup.Append>
                              <InputGroup.Append>
                                <Button
                                  variant={'primary'}
                                  disabled={!test.name}
                                  onClick={async () => {
                                    database.doc(`courses/${course.id}/tests/${test.id}`).update({ name: test.name });
                                  }}
                                >
                                  <FontAwesomeIcon icon={faSave} />
                                </Button>
                              </InputGroup.Append>
                            </InputGroup>
                          </div>
                        </div>
                      </Card.Title>
                    </Card.Header>
                    <Card.Body>
                      {test.questions &&
                        !!test.questions.length &&
                        test.questions.map((question, index) => (
                          <Card key={question.id} className={'mb-2'} bg={(question.answers?.length ?? 0) >= 2 ? undefined : 'warning'}>
                            <Card.Header>
                              <Card.Title className={'mb-0'}>
                                <div className={'d-flex justify-content-between align-items-center'}>
                                  <div className={'d-flex align-items-center flex-grow-1'}>
                                    <InputGroup>
                                      <InputGroup.Prepend>
                                        <InputGroup.Text>Domanda {index + 1}</InputGroup.Text>
                                      </InputGroup.Prepend>
                                      <Form.Control
                                        required
                                        placeholder={'Inserisci il testo della domanda'}
                                        value={question.value}
                                        onChange={(e) => {
                                          question.value = e.target.value;
                                          detectChanges();
                                        }}
                                      />
                                      <InputGroup.Append>
                                        <InputGroup.Text>
                                          <Copyable text={question.id} />
                                        </InputGroup.Text>
                                      </InputGroup.Append>
                                      {!isCourseReadOnly && (
                                        <InputGroup.Append>
                                          <Button
                                            variant={'primary'}
                                            disabled={!question.value}
                                            onClick={async () => {
                                              database.doc(`courses/${course.id}/tests/${test.id}/questions/${question.id}`).update({ value: question.value });
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faSave} />
                                          </Button>
                                        </InputGroup.Append>
                                      )}
                                    </InputGroup>
                                  </div>
                                </div>
                              </Card.Title>
                            </Card.Header>
                            <Card.Body>
                              {question.answers &&
                                !!question.answers.length &&
                                question.answers.map((answer, index) => (
                                  <InputGroup key={answer.id} className="mb-1">
                                    <InputGroup.Prepend>
                                      <InputGroup.Text>Risposta {index + 1}</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                      required
                                      placeholder={'Inserisci il testo della risposta'}
                                      value={answer.value}
                                      onChange={(e) => {
                                        answer.value = e.target.value;
                                        detectChanges();
                                      }}
                                    />
                                    <InputGroup.Append>
                                      <InputGroup.Text>
                                        <Copyable text={answer.id} />
                                      </InputGroup.Text>
                                    </InputGroup.Append>
                                    <InputGroup.Append>
                                      {!isCourseReadOnly && (
                                        <Button
                                          variant={'primary'}
                                          disabled={!answer.value}
                                          onClick={async () => {
                                            database
                                              .doc(`courses/${course.id}/tests/${test.id}/questions/${question.id}/answers/${answer.id}`)
                                              .update({ value: answer.value });
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faSave} />
                                        </Button>
                                      )}
                                      <Button
                                        variant={answer.correct ? 'success' : 'secondary'}
                                        disabled={answer.correct || isCourseReadOnly}
                                        onClick={async () => {
                                          question.answers.forEach((a) => {
                                            if (a.id !== answer.id) {
                                              a.correct = false;
                                            }
                                          });

                                          await Promise.all(
                                            question.answers.map((a) => {
                                              if (a.id !== answer.id) {
                                                return database
                                                  .doc(`courses/${course.id}/tests/${test.id}/questions/${question.id}/answers/${a.id}`)
                                                  .update({ correct: fv.delete() });
                                              }
                                            })
                                          );
                                          detectChanges();

                                          database
                                            .doc(`courses/${course.id}/tests/${test.id}/questions/${question.id}/answers/${answer.id}`)
                                            .update({ correct: !answer.correct ? true : fv.delete() });
                                          answer.correct = !answer.correct;
                                          detectChanges();
                                        }}
                                      >
                                        <FontAwesomeIcon icon={answer.correct ? faCheckSquare : faSquare} />
                                      </Button>
                                    </InputGroup.Append>
                                  </InputGroup>
                                ))}

                              {!isCourseReadOnly && (
                                <Button
                                  variant={'outline-info'}
                                  onClick={async () => {
                                    setCurrentTest(test);
                                    setCurrentQuestion(question);
                                    setNewAnswerModal(true);
                                  }}
                                >
                                  <FontAwesomeIcon icon={faPlus} /> Aggiungi risposta
                                </Button>
                              )}
                            </Card.Body>
                          </Card>
                        ))}

                      {!isCourseReadOnly && (
                        <Button
                          variant={'outline-primary'}
                          onClick={async () => {
                            setCurrentTest(test);
                            setNewQuestionModal(true);
                          }}
                        >
                          <FontAwesomeIcon icon={faPlus} /> Aggiungi domanda
                        </Button>
                      )}
                    </Card.Body>
                  </Card>
                ))}
              </>
            )}
          </Modal.Body>
        </Modal>
      )}

      {!!course && !!units && (
        <Modal
          size={'xl'}
          className={'light-modal'}
          centered
          show={showUnitsModal}
          onHide={() => setShowUnitsModal(false)}
          backdrop={'static'}
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Unità del corso</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!isCourseReadOnly && (
              <Card>
                <Card.Header>
                  <Card.Title className={'mb-0'}>Aggiungi nuova unità</Card.Title>
                </Card.Header>
                <Card.Body>
                  <InputGroup className={'mb-1'}>
                    <InputGroup.Prepend>
                      <InputGroup.Text>Titolo:</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control value={newUnit.name} onChange={(e) => setNewUnit((current) => ({ ...current, name: e.target.value }))} />
                  </InputGroup>
                  <InputGroup className={'mb-1'}>
                    <InputGroup.Prepend>
                      <InputGroup.Text>GUID video:</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control value={newUnit.guid} onChange={(e) => setNewUnit((current) => ({ ...current, guid: e.target.value }))} />
                  </InputGroup>
                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text>Tempo minimo (secondi):</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      type={'number'}
                      value={newUnit.minimumTime}
                      onChange={(e) => setNewUnit((current) => ({ ...current, minimumTime: e.target.value }))}
                    />
                  </InputGroup>
                </Card.Body>
                <Card.Footer>
                  <Button
                    disabled={!newUnit.name || !newUnit.guid || newUnit.minimumTime == '' || newUnit.minimumTime == null}
                    onClick={async () => {
                      const maxOrder = units.length ? Math.max(...units.map((u) => u.order)) : 0;
                      const lastUnit = units.length ? units.find((u) => u.order == maxOrder) : null;
                      let cId = chapterId;
                      if (!cId) {
                        const res = await database.collection(`courses/${course.id}/chapters`).add({
                          name: 'Primo capitolo',
                          order: 0,
                          visible: true,
                        });
                        cId = res.id;
                        setChapterId(cId);
                      }
                      const newUnitObj = {
                        name: newUnit.name,
                        minimumTime: +newUnit.minimumTime,
                        content: database.doc(`videos/${newUnit.guid}`),
                        required: !!course.unitsRequired,
                        lockedBy: !!course.unitsLocked && !!lastUnit ? lastUnit.id : null,
                        order: maxOrder + 10,
                        visible: true,
                      };
                      const res = await database.collection(`courses/${course.id}/chapters/${cId}/units`).add(newUnitObj);
                      units.push({ ...newUnitObj, id: res.id });
                      setNewUnit({
                        name: '',
                        guid: '',
                        minimumTime: '0',
                      });
                    }}
                  >
                    Salva
                  </Button>
                </Card.Footer>
              </Card>
            )}
            <Card className={'mt-2'}>
              <Card.Header>
                <Card.Title className={'mb-0'}>Impostazioni generali</Card.Title>
              </Card.Header>
              <Card.Body>
                <div>
                  <Form.Check
                    type={'checkbox'}
                    id={'chkRequired'}
                    inline
                    label={'Le unità sono obbligatorie'}
                    checked={course.unitsRequired}
                    onChange={(e) => {
                      course.unitsRequired = e.target.checked;
                      database.doc(`courses/${course.id}`).update({ unitsRequired: !!course.unitsRequired });
                      if (units.length) {
                        Promise.all(
                          units.map(({ id }) =>
                            database.doc(`courses/${course.id}/chapters/${course.chapters[0].id}/units/${id}`).update({ required: course.unitsRequired })
                          )
                        );
                        units.forEach((unit) => (unit.required = course.unitsRequired));
                      }
                      detectChanges();
                    }}
                  />
                </div>
                <div>
                  <Form.Check
                    type={'checkbox'}
                    id={'chkLocked'}
                    inline
                    label={'Le unità sono visionabili solo in sequenza'}
                    checked={course.unitsLocked}
                    onChange={(e) => {
                      course.unitsLocked = e.target.checked;
                      database.doc(`courses/${course.id}`).update({ unitsLocked: !!course.unitsLocked });
                      if (units.length) {
                        if (course.unitsLocked) {
                          let prevId = null;
                          const promises = [];
                          for (const unit of units) {
                            if (prevId) {
                              promises.push(
                                database.doc(`courses/${course.id}/chapters/${course.chapters[0].id}/units/${unit.id}`).update({ lockedBy: prevId })
                              );
                              unit.lockedBy = prevId;
                            }
                            prevId = unit.id;
                          }
                          Promise.all(promises);
                        } else {
                          const promises = [];
                          for (const unit of units) {
                            promises.push(
                              database.doc(`courses/${course.id}/chapters/${course.chapters[0].id}/units/${unit.id}`).update({ lockedBy: fv.delete() })
                            );
                            unit.lockedBy = null;
                          }
                          Promise.all(promises);
                        }
                      }
                      detectChanges();
                    }}
                  />
                </div>
                <div className={'text-muted mt-1'}>Il salvataggio di queste impostazioni è automatico nel momento della modifica</div>
              </Card.Body>
            </Card>
            {units.map((unit, idx) => (
              <Card key={unit.id} className={'mt-2'}>
                <Card.Header>
                  <Card.Title className={'mb-0'}>
                    <div className={'d-flex justify-content-between align-items-center'}>
                      <div className={'d-flex align-items-center flex-grow-1'}>
                        <InputGroup>
                          <InputGroup.Prepend>
                            <InputGroup.Text>{idx + 1}.</InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control
                            required
                            placeholder={'Titolo unità...'}
                            value={unit.name}
                            onChange={(e) => {
                              unit.name = e.target.value;
                              detectChanges();
                            }}
                          />
                          <InputGroup.Append>
                            <InputGroup.Text>
                              <Copyable text={unit.id} />
                            </InputGroup.Text>
                          </InputGroup.Append>
                          <InputGroup.Append>
                            <Button
                              variant={'primary'}
                              disabled={!unit.name}
                              onClick={async () => {
                                database.doc(`courses/${course.id}/chapters/${course.chapters[0].id}/units/${unit.id}`).update({ name: unit.name });
                              }}
                            >
                              <FontAwesomeIcon icon={faSave} />
                            </Button>
                          </InputGroup.Append>
                        </InputGroup>
                      </div>
                      <div className={'ml-2'}>
                        <Button
                          as={Badge}
                          variant={unit.visible ? 'success' : 'secondary'}
                          onClick={() => {
                            database.doc(`courses/${course.id}/chapters/${course.chapters[0].id}/units/${unit.id}`).update({ visible: !unit.visible });
                            unit.visible = !unit.visible;
                            detectChanges();
                          }}
                        >
                          <FontAwesomeIcon icon={unit.visible ? faEye : faEyeSlash} className={'mr-1'} fixedWidth={true} />
                          {unit.visible ? 'Visibile' : 'Nascosta'}
                        </Button>
                      </div>
                    </div>
                  </Card.Title>
                </Card.Header>
                <Card.Body>
                  <div>
                    <Badge variant={unit.required ? 'primary' : 'secondary'}>
                      <FontAwesomeIcon icon={unit.required ? faExclamation : faQuestion} className={'mr-1'} fixedWidth={true} />
                      {unit.required ? 'Obbligatoria' : 'Facoltativa'}
                    </Badge>
                    {!!unit.lockedBy && (
                      <Badge variant={'warning'} className={'ml-1'}>
                        <FontAwesomeIcon icon={faLock} className={'mr-1'} fixedWidth={true} />
                        Bloccata dalla precedente
                      </Badge>
                    )}
                  </div>
                  <div className={'mt-2'}>
                    <InputGroup>
                      <InputGroup.Prepend>
                        <InputGroup.Text>GUID video:</InputGroup.Text>
                      </InputGroup.Prepend>
                      <Form.Control
                        required
                        placeholder={'GUID video...'}
                        value={unit.content.id}
                        onChange={(e) => {
                          unit.content.id = e.target.value;
                          detectChanges();
                        }}
                      />
                      <InputGroup.Append>
                        <Button
                          variant={'primary'}
                          disabled={!unit.content.id}
                          onClick={() => {
                            database
                              .doc(`courses/${course.id}/chapters/${course.chapters[0].id}/units/${unit.id}`)
                              .update({ content: database.doc(`videos/${unit.content.id}`) });
                          }}
                        >
                          <FontAwesomeIcon icon={faSave} />
                        </Button>
                      </InputGroup.Append>
                    </InputGroup>
                  </div>
                  <div className={'mt-2'}>
                    <InputGroup>
                      <InputGroup.Prepend>
                        <InputGroup.Text>Tempo minimo (secondi):</InputGroup.Text>
                      </InputGroup.Prepend>
                      <Form.Control
                        required
                        type={'number'}
                        placeholder={'Tempo minimo...'}
                        value={unit.minimumTime || 0}
                        onChange={(e) => {
                          unit.minimumTime = e.target.value;
                          detectChanges();
                        }}
                      />
                      <InputGroup.Append>
                        <Button
                          variant={'primary'}
                          disabled={unit.minimumTime == null || unit.minimumTime == ''}
                          onClick={() => {
                            database.doc(`courses/${course.id}/chapters/${course.chapters[0].id}/units/${unit.id}`).update({ minimumTime: +unit.minimumTime });
                          }}
                        >
                          <FontAwesomeIcon icon={faSave} />
                        </Button>
                      </InputGroup.Append>
                    </InputGroup>
                  </div>
                </Card.Body>
              </Card>
            ))}
          </Modal.Body>
        </Modal>
      )}

      {!!currentTest && !!course && (
        <Modal
          show={newQuestionModal}
          onHide={() => {
            setNewQuestionModal(false);
            setCurrentTest(null);
            setQuestion('');
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Nuova domanda</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={'d-flex justify-content-between align-items-center mt-2'}>
              <div className={'d-flex align-items-center flex-grow-1'}>
                <InputGroup>
                  <Form.Control
                    required
                    placeholder={'Inserisci nuova domanda'}
                    value={question}
                    onChange={(e) => {
                      setQuestion(e.target.value);
                    }}
                  />
                  <InputGroup.Append>
                    <Button
                      variant={'success'}
                      disabled={!question}
                      onClick={async () => {
                        const maxOrder = currentTest.questions?.length ? Math.max(...currentTest.questions.map((q) => q.order)) : 0;
                        const newQuestion = { value: question, order: maxOrder + 10 };
                        const ref = await database.collection(`courses/${course.id}/tests/${currentTest.id}/questions`).add(newQuestion);
                        // se non esiste questions crealo
                        if (!currentTest.questions) currentTest.questions = [];
                        currentTest.questions.push({ ...newQuestion, id: ref.id });
                        detectChanges();
                        setQuestion('');
                        setNewQuestionModal(false);
                      }}
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  </InputGroup.Append>
                </InputGroup>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}

      {!!currentTest && !!currentQuestion && !!course && (
        <Modal
          show={newAnswerModal}
          onHide={() => {
            setNewAnswerModal(false);
            setCurrentTest(null);
            setCurrentQuestion(null);
            setAnswer('');
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Nuova Risposta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={'d-flex justify-content-between align-items-center mt-2'}>
              <div className={'d-flex align-items-center flex-grow-1'}>
                <InputGroup>
                  <Form.Control
                    required
                    placeholder={'Inserisci nuova risposta'}
                    value={answer}
                    onChange={(e) => {
                      setAnswer(e.target.value);
                    }}
                  />
                  <InputGroup.Append>
                    <Button
                      variant={'success'}
                      disabled={!answer}
                      onClick={async () => {
                        const maxOrder = currentQuestion.answers?.length ? Math.max(...currentQuestion.answers.map((a) => a.order)) : 0;
                        const newAnswer = { value: answer, order: maxOrder + 10, correct: !currentQuestion.answers?.length };
                        const ref = await database
                          .collection(`courses/${course.id}/tests/${currentTest.id}/questions/${currentQuestion.id}/answers`)
                          .add(newAnswer);
                        if (!currentQuestion.answers) currentQuestion.answers = [];
                        currentQuestion.answers.push({ ...newAnswer, id: ref.id });
                        detectChanges();
                        setAnswer('');
                        setNewAnswerModal(false);
                      }}
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  </InputGroup.Append>
                </InputGroup>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export { EditCourseComponent as EditCourse };
